import FeedbackContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/FeedbackContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ProgressModel from "../../progress/model/ProgressModel";
import PromiseUtil from "../../util/PromiseUtil";
import ConversationFeedbackEvent from "../event/ConversationFeedbackEvent";

export default class PushConversationFeedbackCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher  
     * @param {ProgressModel} progressModel 
     */
    constructor(dispatcher, progressModel) {
        super(dispatcher);

        this._progressModel = progressModel;

        this._handleConversationFeedbackFinishedBound = this._handleConversationFeedbackFinished.bind(this);
    }

    execute(evt) {
        /** @type {ScenarioPlayerEvent} */
        const data = evt.params.data;
        const { content, contentPlayer } = data;

        /** @type {FeedbackContent} */
        this._content = content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = contentPlayer;

        const conversationId = this._content.getFeedbackName();
        const conversation = this._progressModel.getConversationProgressById(conversationId);

        this._conversationFeedbackScreenSkin = this.openScreen(SkinKeyRegistry.CONVERSATION_FEEDBACK_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            conversation,
        });

        this._dispatcher.addEventListener(ConversationFeedbackEvent.FINISH, this._handleConversationFeedbackFinishedBound);
    }

    async _handleConversationFeedbackFinished(evt) {
        this._dispatcher.removeEventListener(ConversationFeedbackEvent.FINISH, this._handleConversationFeedbackFinishedBound);

        const transitionDuration = 450;
        this.closeScreen(this._conversationFeedbackScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, transitionDuration, createjs.Ease.sineInOut),
        });

        await PromiseUtil.delay(transitionDuration);
        this._contentPlayer.contentCompleted(this._content);
    }
}